import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { environment } from '@environments/environment';
import { Inventory } from '@app/_models/_DTOs/inventory';
import { InventoryService } from '@app/_services/inventory.service';
import { NzMessageService } from 'ng-zorro-antd';
import { Router } from '@angular/router';
import { AssetType } from '@app/_models/enums/assetType';
import { ReportFileType } from '@app/_models/enums/reportFileType';

@Component({
  selector: 'app-inventory-details',
  templateUrl: './inventory-details.component.html',
  styleUrls: ['./inventory-details.component.css']
})
export class InventoryDetailsComponent implements OnInit {

  order: string = 'logTime';
  completionFormat = (percent: number) => `${percent.toFixed(1)} %`;

  @Input() selectedInventory: Inventory;
  @Input() level: number;


  @Output() drawerClosed = new EventEmitter();

  apiUrl: string;

  constructor(private inventoryService: InventoryService,
    private messageService: NzMessageService,
    private router: Router) {
    this.apiUrl = environment.apiUrl;
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  closeDetails() {
    this.selectedInventory = null;
    this.drawerClosed.emit();
  }

  openFoundAssets(){
    this.router.navigate(['found-assets'], { queryParams: { inventoryId: this.selectedInventory.id } });
  }

  getReportSI(){
    this.inventoryService.getReport(this.selectedInventory.id, AssetType.SitniInventar, ReportFileType.Pdf).subscribe((result: any) => {
      if (result.type == 'application/pdf') {
        var blob = new Blob([result], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        }
        else {
          var fileUrl = URL.createObjectURL(blob);
          window.open(fileUrl, '_blank');
        }
      }
      else {
        this.messageService.create("error", "Dokument nije pronađen.");
      }
    }
    );
  }

  getReportOS(){
    this.inventoryService.getReport(this.selectedInventory.id, AssetType.OsnovnoSredstvo, ReportFileType.Pdf).subscribe((result: any) => {
      if (result.type == 'application/pdf') {
        var blob = new Blob([result], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        }
        else {
          var fileUrl = URL.createObjectURL(blob);
          window.open(fileUrl, '_blank');
        }
      }
      else {
        this.messageService.create("error", "Dokument nije pronađen.");
      }
    }
    );
  }

  getReportXls(){
    this.inventoryService.getReport(this.selectedInventory.id, AssetType.OsnovnoSredstvo, ReportFileType.Xls).subscribe((result: any) => {
      if (result.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(result);
        }
        else {
          var fileUrl = URL.createObjectURL(result);
          window.open(fileUrl, '_blank');
        }
      }
      else {
        this.messageService.create("error", "Dokument nije pronađen.");
      }
    }
    );
  }
}
